<template>
  <div>
    <i-box>
      <span slot="title">
        <h5>Filebox Stats</h5>
      </span>
      <span slot="content">
        Total Company Files: {{ numCompanyFiles }}<br><br>
        Total User Files: {{ numMyFiles }}<br><br>
      </span>
    </i-box>
  </div>
</template>

<script>
import IBox from '@/components/common/IBox';

export default {
  name: 'FileboxStats',
  components: { IBox },
  props: {
    numCompanyFiles: {
      type: Number,
      default: 0,
      required: true,
    },
    numMyFiles: {
      type: Number,
      default: 0,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// FileboxStats.vue?51f2097b